<template>
  <div>
    <headingComp :heading="'Percursos'" :icon="require('@/assets/ic-white-percursos.svg')" :backgroundImage="require('@/assets/elvas-castelo.jpg')" :scroll="false"/>
    <section class="percursos-container" v-if="paths">
      <article class="percurso" v-for="path in paths.filter(p => p.translation)" :key="path.id">
        <img src="@/assets/textura-elvas-branco@3x.png">
        <div class="percurso-content">
          <h2>{{path.translation.title}}</h2>
          <p class="type">{{path.translation.type}}</p>
          <p class="description">{{path.translation.description}}</p>
          <router-link :to="'/percurso/' + path.id">
            <elvasButton :button="{title: 'MAIS INFORMAÇÃO'}"></elvasButton>
          </router-link>
        </div>
      </article>
    </section>
  </div>
</template>
<script>

export default {
  name: 'percursos',
  props: [],
  components: {
  },
  data() {
    return {
      paths: null
    }
  },
  async mounted () {
    this.paths = await this.api.get('path')
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
h1 {
  font-size: 80px;
  display: table;
}
.percursos-container {
  width: calc(100% - 160px);
  margin: 0 80px 200px 80px;
  margin-top: -100px;
  position: relative;
  z-index: 5;
  .percurso {
    text-align: center;
    background: #eee3d4;
    display: flex;
    margin-bottom: 50px;
    padding: 50px 0;
    overflow: hidden;
    position: relative;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .percurso-content {
      margin: auto;
      position: relative;
      h2 {
        font-weight: bold;
        font-size: 64px;
        color: #a79374;
      }
      .type {
        margin: 24px 0 26px 0;
        font-size: 16px;
        line-height: 1.5;
        text-align: center;
        color: #a79374;
      }
      p {
        margin-top: 20px;
        padding: 0 50px;
        line-height: 1.56;
        letter-spacing: -0.4px;
        text-align: center; 
        font-size: 18px;
      }
      .elvas-button {
        margin: 25px auto;
      }
    }
  }

  @media (max-width: 700px){
    width: calc(100% - 20px);
    margin: 30px 10px 80px 10px;

    .percurso .percurso-content h2{
      font-size: 40px;
    }
  }

    @media (max-width: 550px){
    width: 100%;
    margin: 30px 0 0;

    &:last-child {
      margin-bottom: 100px;
    }

    .percurso {
      margin-bottom: 20px;
      padding: 50px 8px;
      .percurso-content h2 {
        font-size: 32px;
      }
    }
  }
}
</style>